import React from "react";

export function PageFallback() {
  return (
    <div data-testid="page-loading" className="min-h-[40vh] grid place-items-center">
      <div className="w-6 h-6 rounded-full border-2 border-slate-200 border-t-slate-900 animate-spin" />
    </div>
  );
}
